import Component from '../abstracts/Component';

export default class BenefitBarComponent extends Component {

  get COMPONENTNAME() {
    return 'BenefitBarComponent';
  }

  get SELECTORS() {
    return {
      carouselWrapper: '[data-carousel-wrapper]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      carouselWrapper: this.$component.querySelector(this.SELECTORS.carouselWrapper),
    };
  }

  initCarousel() {
    let options = {
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      vertical: true,
    };
    $(this.dom.carouselWrapper).slick(options);
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initCarousel();
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  render() {
    super.render();
    this.log("Rendering...");
    this.dom = this.readDOM();
    this.importSlick();
  }
}
